import type { BiasEntry } from './biases';

export const biases: BiasEntry[] = [
  {
    id: 26,
    slug: 'congruence-bias',
    name: 'Կոնգրուենտության խեղում',
    scenario: 'A/B-թեստի կարգավորում CTA-ի գույնի վարկածի համար',
    withoutBias:
      'Միայն երկու տարբերակ՝ ներկայիս մոխրագույնը և ենթադրյալ հաղթող կանաչը։ B-ն հաղթում է 3%-ով; թիմը թողարկում է՝ վարկածը հաստատված համարելով։',
    withBias:
      'Չորս տարբերակ, ներառյալ «պետք է պարտվի» կարմիրը և «առանց CTA» կոնտրոլը։ Անսպասելի կարմիրն է հաղթում, բացահայտելով, որ իրական դրայվերը դիրքավորումն էր, ոչ՝ գույնը։',
    whyItWorks:
      'Միայն հաստատելու համար նախագծված թեստը չի կարող հերքել։ Ձեր վարկածով պարտվող պետք եղող տարբերակների ավելացումը ցույց է տալիս՝ իսկապես հասկանում եք համակարգը, թե պարզապես հաջող կռահեցիք։',
    category: 'Decision',
  },
  {
    id: 29,
    slug: 'observer-expectancy-effect',
    name: 'Դիտորդի ակնկալիքի էֆեկտ',
    scenario: 'Վերանորոգված dashboard-ի օգտատերային հարցազրույցի սցենար',
    withoutBias:
      'Առաջնորդող ձևակերպումներ՝ «Համաձա՞յն եք, որ նոր dashboard-ը շատ ավելի արագ է»։ Բոլորը համաձայնում են; թիմը վստահ թողարկում է; churn-ը թռչում է։',
    withBias:
      'Բաց ձևակերպումներ՝ «Պատմեք՝ ինչ արեցիք»։ 6-ից 4-ը խրվում են այն flow-ի վրա, որի մասին ոչ ոք չէր հայտնել, քանի որ նախորդ հարցերը երբեք չէին հարցնում։',
    whyItWorks:
      'Փակ և առաջնորդող ձևակերպումները մասնակցին տալիս են պատասխանը։ Բաց, վարքագծին հիմնված ձևակերպումները ցույց են տալիս, թե մարդիկ իրականում ինչ են անում, և ոչ թե այն, ինչի հետ նրանք քաղաքավարիորեն կհամաձայնվեն։',
    category: 'Perception',
  },
  {
    id: 33,
    slug: 'bias-blind-spot',
    name: 'Խեղումների կույր կետ',
    scenario: 'Senior-թեկնածուի վերաբերյալ հարցազրույցի պանել',
    withoutBias:
      'Ազատ ձևի feedback՝ «Ուժեղ ինտուիցիա։ Հիշեցնում է Ջորդանին պլատֆորմից — այնտեղ լավ ստացվեց»։ 4.5/5 գնահատական՝ առանց ամրացված ապացույցների։',
    withBias:
      'Կառուցվածքային rubric՝ յուրաքանչյուր չափանիշը գնահատական, ապացույց հարցազրույցից և պարտադիր հուշում՝ «նշեք մեկ կոնկրետ պատճառ, թե ինչու այս թեկնածուն կարող է չհաջողել»։',
    whyItWorks:
      'Սեփական խեղումը հնարավոր չէ ինտրոսպեկցիայով տեսնել։ Ապացույցների պարտադրումը յուրաքանչյուր չափանիշի համար և բացահայտ հակափաստարկի հուշումը հանում է այն տարածքը, որտեղ թաքնվում է bias-ը՝ անորոշ տպավորությունները։',
    category: 'Decision',
  },
  {
    id: 38,
    slug: 'illusion-of-validity',
    name: 'Արժանահավատության պատրանք',
    scenario: 'Եռամսյակային կանխատեսում ղեկավարությանը',
    withoutBias:
      '«87% ակտիվացում, բարձր վստահություն»՝ որպես մեկ թավ թիվ։ Ընտրանքի չափը n=12 թաքցված է։',
    withBias:
      '«Հավանական միջակայք 34–91%, n=12»՝ բացահայտ ինտերվալով և զգուշացմամբ՝ չֆիքսել roadmap-ը մինչև n=200։',
    whyItWorks:
      'Փոքր ընտրանքից ստացված մեկ թիվը տեսք ունի վճռական, բայց թաքցնում է հսկայական անորոշություն։ Միջակայք պարտադրելը բացահայտում է տարածումը և կանխում վաղ կոմիթմենտները։',
    category: 'Decision',
  },
  {
    id: 45,
    slug: 'stereotype',
    name: 'Կարծրատիպ',
    scenario: 'SaaS-օգտատերերի անձնավորված dashboard',
    withoutBias:
      'Միևնույն «Engineering Manager» dashboard բոլոր 240 մենեջերների համար — դերը հավասարեցվում է կարիքներին։',
    withBias:
      'Dashboard՝ կենդանի ազդանշաններով՝ վերանայված PR-ներ, բացված widget-ներ, անտեսված մոդուլներ։ Մայան ստանում է on-call + PR-հերթ, ոչ թե հաստիքային պլանավորում, որը նա չի բացում։',
    whyItWorks:
      'Դերը ցույց է տալիս կատեգորիա; վարքը՝ մարդուն։ Իրական ակտիվությունը ամեն անգամ հաղթում է ժողովրդագրական կռահմանը — օգտատերն ինքն այդ ապացուցում է հավելվածի յուրաքանչյուր բացմամբ։',
    category: 'Social',
  },
  {
    id: 52,
    slug: 'out-group-homogeneity',
    name: 'Արտաքին խմբի համասեռություն',
    scenario: 'Free-tier օգտատերերին վերաակտիվացման նամակ',
    withoutBias:
      'Մեկ blast 48,000 free-օգտատերերին՝ «Անցեք Pro-ի և ստացեք ամեն ինչ առանց սահմանափակումների»։ Կոնվերսիան՝ 0.4%։',
    withBias:
      'Երեք վարքագծային սեգմենտ՝ ակտիվ՝ սահմաններին հասնող, պատահական՝ Lite-փաթեթի համար, մեկնարկում խրված՝ կարգավորման ուղեցույց առաջարկվող։ Կոնվերսիան՝ 3.1%։',
    whyItWorks:
      'Free-օգտատերերը մեկ լսարան չեն, այլ՝ երեք լսարան, որոնք կիսում են billing-մակարդակը։ Վարքագծով սեգմենտացիան թույլ է տալիս հաղորդագրությանը հարվածել իրական կարիքին։',
    category: 'Social',
  },
  {
    id: 56,
    slug: 'not-invented-here',
    name: '«Այստեղ չի հորինվել» համախտանիշ',
    scenario: 'B2B-պրոդուկտում աութենտիֆիկացիա ավելացնելու որոշում',
    withoutBias:
      '6-ամսյա ներքին OAuth-մշակում, $420K և 2 ինժեներ։ Roadmap-ը սառեցված է։ Հաճախորդների համար զրո ֆիչա։',
    withBias:
      'Ապացուցված պրովայդեր՝ 2 շաբաթում միացնում, $18K/տարի։ Ինժեներները ազատվում են իրական differentiator-ի համար։',
    whyItWorks:
      '«Ամեն ինչ ինքներս կառուցել»-ու հպարտությունը փակում է աչքերը գնի վրա։ Commodity-շերտը գնելն ու միայն տարբերակողը կառուցելը գրեթե միշտ ճիշտ հարաբերակցությունն է։',
    category: 'Social',
  },
  {
    id: 59,
    slug: 'survival-bias',
    name: 'Փրկվածի սխալ',
    scenario: 'Մարքեթինգային case study-ներ պրոդուկտի կայքում',
    withoutBias:
      'Երեք փայլուն հաղթանակ («+340% MRR», «×5 պահպանում») և «միացեք 1,200 հաջողակ թիմերի» banner։ Ձախողումներն անտեսանելի են։',
    withBias:
      'Ազնիվ բաշխում՝ 12% մեծ հաղթանակ, 51% չափավոր աճ, 24% առանց փոփոխության, 13% հեռացած — բաժնով, թե ով սովորաբար ձախողվում է և ինչպես շուտ նկատել։',
    whyItWorks:
      'Փրկվածները ցույց են տալիս միայն այն, ինչ աշխատում է փրկվածների համար։ Հեռացածներին ցույց տալով՝ կառուցում եք վստահություն և օգնում ճիշտ հաճախորդներին ինքնաընտրել՝ չհեռանալով հետո։',
    category: 'Decision',
  },
  {
    id: 60,
    slug: 'subadditivity-effect',
    name: 'Ենթադիտիվության էֆեկտ',
    scenario: '«Ամեն ինչ ներառված» փաթեթի գնի քարտ',
    withoutBias:
      '«$99/ամս — մեր պլատֆորմի ողջ ֆունկցիոնալը»։ Մեկ թիվ, առանց տրոհման։',
    withBias:
      'Նույն $99-ը տրոհված՝ Պահեստավորում $30 + Աջակցություն $25 + Վերլուծություն $30 + Ինտեգրումներ $24 + Audit $18, և «Խնայում եք $28/ամս՝ առանձին գնելու համեմատ»։',
    whyItWorks:
      'Lump-գինը համեմատվում է մեկ թվի հետ; տրոհվածը՝ հնգի։ Տրոհումը մեծացնում է ընկալվող արժեքը, քանի որ ուղեղը գումարում է բաղադրիչները, և ոչ թե հաշվում ընդհանուր թիվը։',
    category: 'Decision',
  },
  {
    id: 65,
    slug: 'illusion-of-asymmetric-insight',
    name: 'Ասիմետրիկ ընկալման պատրանք',
    scenario: 'Slack-հաղորդագրություն պրոդուկտային որոշմամբ',
    withoutBias:
      '«Կարծում եմ՝ բոլորս համաձայն ենք, որ նոր flow-ը ակնհայտ win է։ Թողարկում ենք ուրբաթ»։ Լռությունը՝ որպես համաձայնություն։',
    withBias:
      'Որոշման տեմպլեյթ՝ ինչ եմ առաջարկում, ինչու, ինչ կարող է բացակայել, ինչպես կհասկանամ՝ սխալ եմ — և խնդրանք «պատասխանեք մեկ բանով, որը կարդացիք այլ կերպ»։',
    whyItWorks:
      'Լռությունը համաձայնություն չէ, այլ՝ երկիմաստություն։ Կառուցվածքային բացահայտումը և անհամաձայնության կոնկրետ խնդրանքը բացահայտում են այն ճեղքվածքը, որը կա ուղարկվածի և լսվածի միջև։',
    category: 'Social',
  },
  {
    id: 67,
    slug: 'planning-fallacy',
    name: 'Պլանավորման սխալ',
    scenario: 'Ինժեներական գնահատական billing-համակարգի միգրացիայի համար',
    withoutBias:
      'Մեկ թիվ՝ «3 օր»։ Թողարկվեց 18 օր ուշացումով; 2-րդ շաբաթում հաճախորդներից կրկնակի գանձեց։',
    withBias:
      'Եռակետանի գնահատական (3օ / 7օ / 14օ)՝ պատմական հարաբերակցությանը խարսխված. նախորդ 3 նմանատիպ պրոյեկտներն իրականում տևեցին 2.5×։',
    whyItWorks:
      'Միայնակ գնահատականներում գերակշռում է լավատեսությունը։ Եռակետանի միջակայքերը՝ պատմական փաստերի հետ, ստիպում են թիմին ազնիվ նայել, թե ինչպես են իր անցյալի գնահատականները բռնել իրականությունը։',
    category: 'Decision',
  },
  {
    id: 68,
    slug: 'pro-innovation-bias',
    name: 'Պրո-ինովացիոն խեղում',
    scenario: 'Editor 2.0-ի թողարկում երկար գործող պրոդուկտում',
    withoutBias:
      '«Հնագույն խմբագրիչը հեռանում է — անցեք հիմա»՝ մեկ մեծ կոճակով։ Շաբաթվա #1 support-tikket-ը՝ workflow-ները կոտրված՝ թողարկումից առաջ։',
    withBias:
      '«Նոր խմբագրիչը հասանելի է — Classic-ը մնում է մինչև 2027»։ Երկու կոճակ (փորձել բետան / մնալ Classic-ում) և բացահայտ աջակցության խոստում։',
    whyItWorks:
      'Պարտադրված միգրացիան օգտատերերի կուտակած աշխատանքային հոսքերը համարում է ծախսվող նյութ։ Համատեղ գոյությունը հարգում է այն, ինչ արդեն աշխատում է, և վաստակում է բարելավումը, երբ այն իսկապես ժամանակ կխնայի։',
    category: 'Decision',
  },
  {
    id: 69,
    slug: 'overconfidence-effect',
    name: 'Ինքնավստահության էֆեկտ',
    scenario: 'Եռամսյակային ակտիվ-օգտատեր կանխատեսում',
    withoutBias:
      'Կետային գնահատական (420,000)՝ ինքնագնահատված 95% վստահությամբ։ Պատմական hit-rate այդ մակարդակում՝ 41%։',
    withBias:
      'Պարտադրված 90% միջակայք (290,000–610,000)՝ կալիբրացիայի կանոններով և կանխատեսում–փաստ հետևելու սովորույթով, որպեսզի ապագա միջակայքերը դառնան ավելի ճշգրիտ։',
    whyItWorks:
      'Ինքնագնահատված վստահությունը անվստահելի է; 90%-անոց միջակայքը դժվար է կեղծել — այն ստիպում է ընդունել, թե որքան լայն կարող է լինել իրականությունը։ Ժամանակի ընթացքում կալիբրացիան միջակայքերը դարձնում է ավելի սեղմ ազնվորեն։',
    category: 'Decision',
  },
  {
    id: 72,
    slug: 'consensus-bias',
    name: 'Կեղծ կոնսենսուսի էֆեկտ',
    scenario: 'Onboarding-flow-ի ընտրություն ներքին քվեարկությամբ',
    withoutBias:
      'Թիմի հարցում՝ 71%-ը կողմ է «արագ tour»-ին։ Որոշում՝ թողարկում ենք tour-ը — օգտատերերին էլ կտեսնի։',
    withBias:
      'Թիմի հարցում + հաճախորդների հարցում (n=412)՝ հաճախորդների միայն 12%-ն է ընտրում tour; 65%-ը ուզում է demo-տեսանյութ։',
    whyItWorks:
      'Համաձայնեցող սենյակը գնող սենյակ չէ։ Ներքին նախասիրությունը հաճախորդների իրական ազդանշանի հետ համադրելը բացահայտում է ճեղքվածքը, նախքան այն թողարկման ձախողում կդառնա։',
    category: 'Social',
  },
  {
    id: 95,
    slug: 'law-of-triviality',
    name: 'Տրիվիալության օրենք',
    scenario: 'Sprint-պլանավորման օրակարգ',
    withoutBias:
      '52 րոպե «teal vs navy CTA»-ի վրա, քանի որ բոլորն ունեն կարծիք։ 8 րոպե այն DB-միգրացիայի վրա, որը կարող է checkout-ը կոտրել։',
    withBias:
      'Time-box-ով օրակարգ՝ 45ր միգրացիայի պլանի վրա, 25ր error-budget քաղաքականության վրա, 5ր յուրաքանչյուր bikeshed-թեմայի՝ default-ով մեկ owner-ի կանոնով։',
    whyItWorks:
      'Տրիվիալ որոշումները հրավիրում են մասնակցություն — բոլորը կարող են կարծիք ունենալ; կարևորները հակառակը՝ վախեցնում։ Time-box ըստ ազդեցության հարթեցնում է ուշադրությունը՝ ընդհանուր նշանակության հետ։',
    category: 'Social',
  },
  {
    id: 98,
    slug: 'implicit-stereotypes',
    name: 'Իմպլիցիտ կարծրատիպեր',
    scenario: 'Ինժեներական դերի համար take-home առաջադրանքի սկզբնական զննում',
    withoutBias:
      'Reviewer-ը տեսնում է անունը, լուսանկարը, համալսարանը։ Callback-ի տոկոս հավասար հմտություններով թեկնածուների համար թերներկայացված խմբերից՝ 11%։',
    withBias:
      'Blind review՝ անունը, լուսանկարն ու համալսարանը թաքնված են մինչև հարցազրույց։ Callback-ի տոկոսը հավասար հմտություններով՝ 34%։',
    whyItWorks:
      'Իմպլիցիտ ասոցիացիաները ակտիվանում են ավելի արագ, քան կանխամտածված դատողությունը։ Գնահատման պահին տրիգերը հանելը թույլ է տալիս աշխատանքի վերաբերյալ խոսել միայն աշխատանքին, և տվյալները անմիջապես ցույց են տալիս, թե ինչպես է ճեղքվածքը փակվում։',
    category: 'Social',
  },
];
